{
  "unauthorizedRoute": {
    "subtitle": "Vous n'avez pas l'autorisation d'accéder à cette page",
    "title": "Non autorisé"
  },
  "pageNotFound": "Page non trouvée",
  "httpStatusCodes": {
    "400": {
      "title": "Erreur de requête",
      "subtitle": "Une erreur de requête est survenue, veuillez vérifier vos données et réessayer.",
      "codes": {
        "INVALID_VALUE_NOT_NULL": "Le champ \"{field}\" est obligatoire.",
        "JSON_NOT_VALID": "Le contenu n'est pas un format JSON valide.",
        "SCHEMA_NOT_MATCH": "Le contenu ne correspond pas au schéma attendu.",
        "SCHEMA_NOT_MATCH_FIELD": "Le contenu ne correspond pas au schéma attendu, erreur sur la propriété \"{field}\".",
        "CERTIFICATE_RENEWAL_FAILED_NO_DNS_MATCH": "Le DNS et le CN du certificat ne correspondent pas à la configuration du certificat."
      }
    },
    "409": {
      "title": "Erreur de conflit",
      "subtitle": "Une erreur de conflit est survenue, veuillez vérifier vos données et réessayer.",
      "codes": {
        "UNICITY_CONSTRAINT": "La valeur du champ \"{field}\" est déjà utilisée.",
        "UNICITY_CONSTRAINT_FIELD_LOGIN": "Le login est déjà utilisé.",
        "UNICITY_CONSTRAINT_FIELD_EMAIL": "L’adresse email est déjà utilisée.",
        "UNICITY_CONSTRAINT_FIELD_NAME_ORGANIZATION": "Le nom de l’organisation est déjà utilisé.",
        "UNICITY_CONSTRAINT_FIELD_USER_GROUP": "Un groupe d'utilisateur avec ce nom existe déjà.",
        "UNICITY_CONSTRAINT_FIELD_USER_PROFILE": "Un profil avec ce nom existe déjà."
      }
    },
    "404": {
      "title": "Introuvable",
      "subtitle": "La resource n'est pas disponible ou a été supprimée."
    },
    "401": {
      "title": "Non connecté",
      "subtitle": "Vous n'êtes pas connecté."
    },
    "403": {
      "title": "Accès non autorisé",
      "subtitle": "Vous n'avez pas les autorisations nécessaires.",
      "codes": {
        "SECTOR_DEPTH_EXCEEDED": "La profondeur maximale des secteurs ne peut pas excéder {maximum_allowed_depth}.",
        "SECTOR_DELETE_FORBIDDEN": "Le secteur ne peut pas être supprimé car des équipements y sont rattachés."
      }
    },
    "500": {
      "title": "Une erreur est survenue",
      "subtitle": "Merci de réessayer ultérieurement."
    },
    "405": {
      "title": "Accès non autorisé",
      "subtitle": "Vous n'avez pas les autorisations nécessaires."
    },
    "408": {
      "title": "Impossible de charger la page",
      "subtitle": "La requête a mis trop de temps à répondre."
    }
  },
  "download": {
    "noData": "Aucune donnée à télécharger"
  }
}
